<mat-card appearance="outlined" class="select-document-type-modal">
    <mat-card-header>
        <mat-card-title>{{ "APP_CREATE_CASE.SELECT_DOCUMENT_TYPE" | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-radio-group fxLayout="column" fxLayoutAlign="start start" [(ngModel)]="DocumentType">
            <div *ngFor="let option of Options; let i = index" class="document-type-options">
                <mat-radio-button [value]="option">
                    {{ "APP_CREATE_CASE." + option | translate }}
                </mat-radio-button>
            </div>
        </mat-radio-group>
    </mat-card-content>
    <mat-card-actions fxLayout="row" fxLayoutGap="16" fxLayoutAlign="center center">
        <button *ngIf="ButtonNoText" mat-button appGhostButton (click)="cancel()">
            <mat-icon>close</mat-icon>
            {{ ButtonNoText | translate | uppercase }}
        </button>

        <button *ngIf="ButtonYesText" mat-button appPrimaryButton (click)="submitForm()">
            <mat-icon>check</mat-icon>
            {{ ButtonYesText | translate | uppercase }}
        </button>
    </mat-card-actions>
</mat-card>
